import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './form.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelopeCircleCheck,
  faHouse,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';

export default function RegisterSuccess() {
  useEffect(() => { AOS.init({ duration: 600, once: true }); }, []);

  return (
    <div className="jm-result-page">
      <div className="jm-result-card" data-aos="zoom-in">
        <div className="jm-result-icon-wrap">
          <div className="jm-result-icon info">
            <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
          </div>
        </div>

        <div className="jm-result-body">
          <h2>Registration Submitted!</h2>
          <p>
            Your registration details have been received. Please check your email for
            further instructions and your e-ticket once payment is confirmed.
          </p>

          <div className="jm-result-actions">
            <Link to="/" className="jm-rbtn primary">
              <FontAwesomeIcon icon={faHouse} />
              Go to Home
            </Link>
            <Link to="/register" className="jm-rbtn outline">
              Register Another
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </div>

        <div className="jm-result-foot">
          <p>Didn't receive an email? Check your spam folder or contact <a href="mailto:rcaiitkgp.payment@gmail.com">rcaiitkgp.payment@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}
